import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Home } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome ? "nav-scrolled" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="navbar-logo"
        >
          <div className="w-10 h-10 bg-vastu-terracotta rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
            <Home size={18} className="text-white" />
          </div>
          <span
            className="font-heading text-2xl font-semibold transition-colors duration-300"
            style={{ color: scrolled || !isHome ? "#2D2A26" : "white" }}
          >
            Vastu<span style={{ color: "#D27C2C" }}>Net</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {["About Vastu", "Principles", "How It Works", "FAQ"].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase().replace(/ /g, "-")}`}
              className="hover:text-vastu-terracotta transition-colors duration-300 font-body text-sm font-medium tracking-wide"
              style={{ color: scrolled || !isHome ? "#6B6863" : "rgba(255,255,255,0.8)" }}
              data-testid={`nav-${item.toLowerCase().replace(/ /g, "-")}`}
            >
              {item}
            </a>
          ))}
          <Link
            to="/get-floor-plan"
            className="btn-primary text-sm py-3 px-6"
            data-testid="nav-cta-btn"
          >
            Get Floor Plan
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-vastu-muted transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {menuOpen ? (
            <X size={24} className="text-vastu-charcoal" />
          ) : (
            <Menu size={24} className="text-vastu-charcoal" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          className="md:hidden bg-vastu-cream border-t border-vastu-border px-6 py-6 flex flex-col gap-5"
          data-testid="mobile-menu"
        >
          <a
            href="#about"
            className="text-vastu-charcoal hover:text-vastu-terracotta font-body font-medium py-2"
            onClick={() => setMenuOpen(false)}
          >
            About Vastu
          </a>
          <a
            href="#principles"
            className="text-vastu-charcoal hover:text-vastu-terracotta font-body font-medium py-2"
            onClick={() => setMenuOpen(false)}
          >
            Principles
          </a>
          <a
            href="#how-it-works"
            className="text-vastu-charcoal hover:text-vastu-terracotta font-body font-medium py-2"
            onClick={() => setMenuOpen(false)}
          >
            How It Works
          </a>
          <a
            href="#faq"
            className="text-vastu-charcoal hover:text-vastu-terracotta font-body font-medium py-2"
            onClick={() => setMenuOpen(false)}
          >
            FAQ
          </a>
          <Link
            to="/get-floor-plan"
            className="btn-primary text-center py-3"
            onClick={() => setMenuOpen(false)}
            data-testid="mobile-cta-btn"
          >
            Get Floor Plan
          </Link>
        </div>
      )}
    </nav>
  );
}
